import React, { PureComponent } from 'react'
import { Col, Icon,Layout,Form,Input, Select } from 'antd'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { getData } from '../../api/api'
import { getRandomN } from '../../utils/tool'
import instance from '../../api/bankRequest'
import './style/home.less'
const { Content  } = Layout
const { Option } = Select

@observer
class Home extends PureComponent {
	@observable dataInfo = ''
	@observable mbrCode = '0154100004437366'
	
	getBalance = () =>{
		const param = {
			trxCode:'400002',
			mbrCode: this.mbrCode
		}
		getData(param).then(res =>{
			this.dataInfo = res.data.split('&')
			document.forms[0].submit();
		})
	}

	getTrading = () =>{
		const param = {
			trxCode:'410010',
			mbrCode: this.mbrCode
		}
		getData(param).then(res =>{
			this.dataInfo = res.data.split('&')
			document.forms[0].submit();
		})
	}
	download = () =>{
		const param = {
			trxCode:'600002',
			jrnno:getRandomN()
		}
		getData(param).then(res =>{
			this.dataInfo = res.data.split('&')
			document.forms[0].submit();
		})
	}

	resetPassword = () =>{
		const param = {
			trxCode:'100009',
			mbrCode: this.mbrCode,
			pageRetUrl:'http://ccb-web.gdhttech.com/#/result',
			operType:'18'
		}
		getData(param).then(res =>{
			this.dataInfo = res.data.split('&')
			document.forms[0].submit();
		})
	}

	infoChange = () =>{
		const param = {
			trxCode:'100007',
			mbrCode: this.mbrCode,
			pageRetUrl:'http://ccb-web.gdhttech.com/#/result',
			operType:'15',
			bgRetUrl:'http://teruo-home.gdhttech.com/pay/back'
		}
		getData(param).then(res =>{
			this.dataInfo = res.data.split('&')
			document.forms[0].submit();
		})
	}

	render() {
		const { dataInfo } = this
		return (
			<Layout className="Home">
				<Content>
					<div style={{fontSize:22,marginBottom:60}}>
						<span>请选择查询商户：</span>
						<Select style={{width:200}} onChange={(v) =>{this.mbrCode=v}}
							placeholder='请选择查询商户'
							defaultValue={'0154100004437366'}
						>
							<Option value={'0154100004437366'} key={'1'}>慧途科技（惠州）有限责任公司</Option>
						</Select>
					</div>
					<Col xs={3} sm={6} md={8} lg={8} xl={8} className='item' onClick={ () => {this.props.history.push(`/elect`)}}>
						<Icon type="form" style={{fontSize:60,color:'#333'}} />
						<div className='txt'>电子登记簿</div>
					</Col>
					<Col xs={3} sm={6} md={8} lg={8} xl={8} className='item' onClick={ () => {this.props.history.push(`/withdraw`)}}>
						<Icon type="money-collect" style={{fontSize:60,color:'#333'}} />
						<div className='txt'>出金申请</div>
					</Col>
					<Col xs={3} sm={6} md={8} lg={8} xl={8} className='item' onClick={ () => {this.props.history.push(`/AutoWithdraw`)}}>
						<Icon type="transaction" style={{fontSize:60,color:'#333'}} />
						<div className='txt'>自动提现申请</div>
					</Col>
					<Col xs={3} sm={6} md={8} lg={8} xl={8} className='item' onClick={this.getBalance}>
						<Icon type="pay-circle" style={{fontSize:60,color:'#333'}} />
						<div className='txt'>电子登记簿余额信息</div>
					</Col>
					<Col xs={3} sm={6} md={8} lg={8} xl={8} className='item' onClick={this.getTrading}>
						<Icon type="file-search" style={{fontSize:60,color:'#333'}} />
						<div className='txt'>收款方待结算交易明细</div>
					</Col>
					<Col xs={3} sm={6} md={8} lg={8} xl={8} className='item' onClick={this.download}>
						<Icon type="download" style={{fontSize:60,color:'#333'}} />
						<div className='txt'>对账文件</div>
					</Col>
					<Col xs={3} sm={6} md={8} lg={8} xl={8} className='item' onClick={this.resetPassword}>
						<Icon type="lock" style={{fontSize:60,color:'#333'}} />
						<div className='txt'>重置交易密码</div>
					</Col>
					<Col xs={3} sm={6} md={8} lg={8} xl={8} className='item' onClick={this.infoChange}>
						<Icon type="interaction" style={{fontSize:60,color:'#333'}} />
						<div className='txt'>企业用户信息变更</div>
					</Col>
				</Content>
				<Form method='post' action={instance.baseURL+'/bhdep/payTransactionNew'} style={{display:'none'}} >
                    <Input type='text' name='INFO' value={dataInfo? dataInfo[0].substring(5):''}/>
                    <Input type='text' name='BODY' value={dataInfo? dataInfo[1].substring(5):''}/>
                    <Input type='text' name='SIGN' value={dataInfo? dataInfo[2].substring(5):''}/>
                    <Input type='text' name='CONTENTTYPE' value='json'/>
                    <Input type='submit' value='提交' />
                </Form>
			</Layout>
		)
	}
}
export default Home
